import { useEffect, useRef, useState } from "react";
import { DataGrid, Column } from "devextreme-react/data-grid";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Button as DxButton } from "devextreme-react/button";
import { confirm } from "devextreme/ui/dialog";
import { ModalBulkSiteCreationProps } from "./BulkSiteCreation.types";
import { useSnackbar } from "../../hooks";
import { Modal } from "../../cui/components/Modal/Modal";
import { BulkSitesChangeDetailsDTO } from "../../api-client-nswag/taxportal-client";
import { constants } from './BulkSiteCreation.types'
import { createSitesClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import { ModalBulkSiteCreationSubDetail } from "./ModalBulkSiteCreationSubDetail";

type DatagridRefType = DataGrid;
const { DETAILS_TITLE } = constants;
const initialStateData = { pending: true, changes: [] };

export const ModalBulkSiteCreationDetail = ({
  handleClose,
  isDisplayModal,
  siteId,
  userEmail
}: ModalBulkSiteCreationProps) => {
  const detailsGridRef = useRef<DatagridRefType>(null);

  const { showSnackbar } = useSnackbar();
  const [changesDetailData, setChangesDetailData] = useState<any>(initialStateData);
  const [isDisplayDetailsModal, setIsDisplayDetailsModal] = useState(false);
  const [selectedChange, setSelectedChange] = useState<any>();
  const [isDisabled, setDisabled] = useState<boolean>(false);

  const fetchData = async () => {
    try {
      if (!siteId) {
        setChangesDetailData({ pending: false, changes: [] });
        return;
      }
      setChangesDetailData(initialStateData);
      const result = await createSitesClientApi.taxportal_GetProcessExecutionDetails(String(siteId));
      setChangesDetailData({ pending: false, changes: result?.data });
    } catch (error) {}
  };

  const handleSeeDetailsButton = (data: BulkSitesChangeDetailsDTO) => {
    setSelectedChange({ ...data });
    setIsDisplayDetailsModal(true);
  };

  const handleCloseDetailsModal = () => {
    setSelectedChange({});
    setIsDisplayDetailsModal(false);
  };

  const renderRetry = ({ row: { data } }: any) => {
    if (!data.id) return;
    return data.id ? (
         <DxButton
          onClick={() => handleRetryButton(data.id)}
          icon="refresh"
          className="hq-icon-button"
          disabled={isDisabled}
        />
      ) : null;
  };

  const handleRetryButton = async (processId: string) => {
    const result = await confirm("Are you sure you want to continue?", "Please Confirm");
    if (result) {
      setDisabled(true)
      const payload: any =  { "processExecutionId" : processId }
      const response = await createSitesClientApi.taxportal_retryStep(processId, payload, userEmail);
      if(response) {
        setDisabled(false);
        fetchData();
      }
    } else {
    }
  }

   const renderDetails = ({ row: { data } }: any) => {
    if (!data.id) return;
    return data.id ? (
        <IconButton
          className="dx-datagrid dx-link"
          aria-label="See Details"
          title="See Details"
          onClick={() => handleSeeDetailsButton(data)}
        >
          <SearchIcon />
        </IconButton>
      ) : null;
  };

  useEffect(() => {
    fetchData();
  }, [siteId]);

  return (
    <Modal
      title={DETAILS_TITLE}
      maxWidth="xl"
      btnCloseText="Cancel"
      isDisplayModal={isDisplayModal}
      handleClose={handleClose}
    >
      <>
        <DataGrid
          id="grid-modal-changes"
          ref={detailsGridRef}
          keyExpr="id"
          allowColumnResizing
          dataSource={changesDetailData.changes}
          noDataText={changesDetailData.pending ? "Loading..." : "No data"}
          showBorders
          wordWrapEnabled
        >
          <Column dataField="processDescription" caption="Process Description" />
          <Column dataField="status" caption="Status" />
          <Column dataField="statusMessage" caption="Status Message"/>
          <Column dataField="retry" caption="Retry Count"  width="150px" />
          <Column cellRender={renderDetails} type="buttons" caption="Process Execution Detail" />
          <Column cellRender={renderRetry} type="buttons" caption="Retry" />
        </DataGrid>

        <ModalBulkSiteCreationSubDetail
          id={selectedChange?.id}
          isDisplayModal={isDisplayDetailsModal}
          handleClose={handleCloseDetailsModal}
        />
      </>
    </Modal>
  );
};
